import { produce } from "immer"

import { CheckoutExperimentsDefinition } from "@modules/signup-and-order-flow/experiments/experiment-interfaces"

import { SessionData, SessionAction, SessionActionType, FlowType } from "./session-types"

// Initial state
export const createInitialState = (treatments: CheckoutExperimentsDefinition): SessionData => ({
  product: {
    productId: null,
    calculatedPrices: null,
    preSelectedInstallment: undefined,
    cartTotal: null,
  },
  user: {
    userUuid: null,
  },
  progress: {
    paymentOptionsCompleted: false,
    signupCompleted: false,
    orderPlaced: false,
    serverErrorOccurred: false,
    startedSignupFlow: false,
  },
  flowType: FlowType.SIGN_UP,
  treatments,
})

// Reducer function
export const sessionReducer = (state: SessionData, action: SessionAction): SessionData => {
  return produce(state, (draft) => {
    switch (action.type) {
      case SessionActionType.UPDATE_PRODUCT:
        Object.assign(draft.product, action.payload)
        break
      case SessionActionType.UPDATE_USER:
        Object.assign(draft.user, action.payload)
        break
      case SessionActionType.UPDATE_PROGRESS:
        Object.assign(draft.progress, action.payload)
        break
      case SessionActionType.UPDATE_FLOW_TYPE:
        draft.flowType = action.payload
        break
      case SessionActionType.RESET_SESSION:
        return createInitialState(state.treatments)
      case SessionActionType.SET_SESSION:
        return action.payload
    }
  })
}
